const bodyClassCounts = new Map();

export function acquireBodyClass(className) {
  if (typeof document === "undefined" || !className) {
    return () => {};
  }

  const nextCount = (bodyClassCounts.get(className) || 0) + 1;
  bodyClassCounts.set(className, nextCount);
  document.body.classList.add(className);

  return () => {
    const currentCount = bodyClassCounts.get(className) || 0;
    if (currentCount <= 1) {
      bodyClassCounts.delete(className);
      document.body.classList.remove(className);
      return;
    }

    bodyClassCounts.set(className, currentCount - 1);
  };
}
